'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLogger;

var _util = require('util');

// Server side redux action logger
function createLogger(shouldLog) {
    return function (store) {
        return function (next) {
            return function (action) {
                if (!shouldLog) return next(action);

                var formattedPayload = (0, _util.inspect)(action.payload, { colors: true });
                // eslint-disable-next-line no-console
                console.log(' * ' + action.type + ': ' + formattedPayload);
                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/logger/serverLogger.js
// module id = G3Tb
// module chunks = 57